import React from 'react'

import { Datagrid, List, ReferenceField, TextField, useGetIdentity } from 'react-admin'
import { MembershipListActions } from './Actions'
import { StatusField } from '../StatusField'

export const MembershipList = () => {
  const { identity, isLoading: identityLoading } = useGetIdentity()
  if (identityLoading) return null

  const { user, account } = identity
  if (!user) return null

  const userId = user.id

  // TODO Add sortable={false} - currently this breaks graphql
  return (
    <List pagination={false} exporter={false} perPage={25} filter={{ userId, status: 'active,invited' }}>
      <Datagrid rowClick={null} bulkActionButtons={false}>
        <ReferenceField label="Account" source="account.id" reference="Account" link="">
          <TextField source="name" />
        </ReferenceField>
        <StatusField source="status" />
        {/* <DateField source="createdAt" /> */}
        <MembershipListActions account={account} source="actions" />
      </Datagrid>
    </List>
  )
}
